/**
 * Smart Health Ring PDP
 * - Gallery above title, image changes with color
 * - Bundle: color + size per ring
 * - Multi-variant add to cart
 */
(function () {
  function forceUnlockScroll() {
    try {
      document.documentElement.classList.remove('sr-modal-open');
      document.body.classList.remove('sr-modal-open');
      document.documentElement.removeAttribute('scroll-lock');
      var pw = document.querySelector('.page-wrapper');
      if (pw) {
        pw.style.removeProperty('overflow');
        pw.style.removeProperty('overflow-y');
        delete pw.dataset.srPrevOverflow;
      }
    } catch (e) {}
  }

  // Alias kept for callers throughout this module. Was referenced (init,
  // closeModal) but never defined, which threw a ReferenceError mid-init and
  // left the funnel "Add to cart" button unbound. Delegates to the full unlock.
  function unlockPageScroll() {
    forceUnlockScroll();
  }

  forceUnlockScroll();

  const root = document.querySelector('[data-smart-ring-pdp]');
  if (!root) return;

  // Bind Get started / modal chrome FIRST — never leave CTA dead if JSON/init fails later
  let modal = root.querySelector('[data-sr-modal]') || document.querySelector('[data-sr-modal]');
  const stickyBarEarly = document.querySelector('[data-sr-sticky]');
  if (stickyBarEarly && stickyBarEarly.parentElement !== document.body) {
    document.body.appendChild(stickyBarEarly);
  }
  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  function openModalEarly() {
    modal = root.querySelector('[data-sr-modal]') || document.querySelector('[data-sr-modal]') || modal;
    if (!modal) return false;
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    modal.hidden = false;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sr-modal-open');
    document.body.classList.add('sr-modal-open');
    if (stickyBarEarly) {
      stickyBarEarly.classList.remove('is-visible');
      stickyBarEarly.setAttribute('aria-hidden', 'true');
      stickyBarEarly.hidden = true;
    }
    const step1 = modal.querySelector('[data-sr-step="1"]');
    if (step1) {
      modal.querySelectorAll('[data-sr-step]').forEach((p) => {
        const show = p.getAttribute('data-sr-step') === '1';
        p.hidden = !show;
        p.classList.toggle('is-active', show);
      });
    }
    const funnel = modal.querySelector('[data-sr-funnel]');
    if (funnel) funnel.setAttribute('data-step', '1');
    return true;
  }

  function closeModalEarly() {
    modal = root.querySelector('[data-sr-modal]') || document.querySelector('[data-sr-modal]') || modal;
    if (modal) {
      modal.hidden = true;
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
    }
    forceUnlockScroll();
    if (stickyBarEarly) stickyBarEarly.hidden = false;
  }

  if (!window.__srFunnelClickBound) {
    window.__srFunnelClickBound = true;
    document.addEventListener(
      'click',
      function (e) {
        const t = e.target;
        if (!(t instanceof Element)) return;
        if (t.closest('[data-sr-funnel-start]')) {
          e.preventDefault();
          openModalEarly();
          return;
        }
        if (t.closest('[data-sr-modal-close]')) {
          e.preventDefault();
          closeModalEarly();
        }
      },
      true
    );
  }

  const productJsonEl = root.querySelector('[data-product-json]');
  const colorMapEl = root.querySelector('[data-color-image-map]');
  if (!productJsonEl) {
    console.warn('[smart-ring-pdp] missing product JSON — funnel UI only');
    return;
  }

  let product;
  try {
    product = JSON.parse(productJsonEl.textContent || '{}');
  } catch (err) {
    console.warn('[smart-ring-pdp] invalid product JSON', err);
    return;
  }

  let colorImageMap = {};
  try {
    colorImageMap = JSON.parse(colorMapEl?.textContent || '{}');
  } catch {
    colorImageMap = {};
  }

  const form = root.querySelector('[data-sr-product-form]') || document.querySelector('[data-sr-product-form]');
  const variantInput =
    root.querySelector('[data-sr-variant-id]') || document.querySelector('[data-sr-variant-id]');
  const qtyInput = root.querySelector('[data-sr-quantity]') || document.querySelector('[data-sr-quantity]');
  const bundleProp =
    root.querySelector('[data-sr-bundle-prop]') || document.querySelector('[data-sr-bundle-prop]');
  const priceEl = root.querySelector('[data-sr-price]');
  const compareEl = root.querySelector('[data-sr-compare]');
  const saveEl = root.querySelector('[data-sr-save]');
  const stickyBar = stickyBarEarly || document.querySelector('[data-sr-sticky]');
  // Horizon scrolls .page-wrapper — keep scroll detection on it,
  // but mount overlays on body so fixed layers never trap scroll/clicks.
  const pageWrapper = document.querySelector('.page-wrapper');
  const stickyPrice = document.querySelector('[data-sr-sticky-price]');
  const stickyVariantEl = document.querySelector('[data-sr-sticky-variant]');
  const stickyImg = document.querySelector('[data-sr-sticky-img]');
  const stickyTitle = document.querySelector('[data-sr-sticky-title]');
  const mainImg = root.querySelector('[data-sr-main-img]');
  const heroImg = root.querySelector('[data-sr-hero-img]');
  const thumbs = root.querySelector('[data-sr-thumbs]');
  const bundleGallery = root.querySelector('[data-sr-bundle-gallery]');
  const errorEl = root.querySelector('[data-sr-error]') || document.querySelector('[data-sr-error]');
  const addButtons = document.querySelectorAll('[data-sr-add]');
  const optionSentinel = root.querySelector('[data-sr-offer-sentinel]');
  const mainAddBtn =
    root.querySelector('.sr-buy [data-sr-funnel-start]') ||
    root.querySelector('.sr-buy [data-sr-add], [data-sr-funnel-atc]');
  const pitchVideo = root.querySelector('[data-sr-autoplay-video]');

  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  const colorOptionIndex = parseInt(root.dataset.colorOptionIndex || '-1', 10);
  const sizeOptionIndex = parseInt(root.dataset.sizeOptionIndex || '-1', 10);

  // Keep a stable local list — never rely on product.variants (can be missing on LP product JSON)
  const productVariants = Array.isArray(product?.variants) ? product.variants : [];

  // Prefer first available variant (first color + first available size)
  const initial = productVariants.find((v) => v.available) || productVariants[0] || null;

  function optionOf(variant, index) {
    if (!variant || index < 0) return '';
    return String(variant['option' + (index + 1)] || '');
  }

  const initialColor = optionOf(initial, colorOptionIndex);
  const initialSize = optionOf(initial, sizeOptionIndex);

  /** @type {{ color: string, size: string }[]} */
  const units = [
    { color: initialColor, size: initialSize },
    { color: initialColor, size: initialSize },
    { color: initialColor, size: initialSize },
  ];

  const funnelRoot = root.querySelector('[data-sr-funnel]') || modal?.querySelector('[data-sr-funnel]');
  // modal already resolved above
  const atcBtn = root.querySelector('[data-sr-funnel-atc]') || modal?.querySelector('[data-sr-funnel-atc]');
  const selectedColorEl =
    root.querySelector('[data-sr-selected-color]') || modal?.querySelector('[data-sr-selected-color]');
  const funnelSummaryEl =
    root.querySelector('[data-sr-funnel-summary]') || modal?.querySelector('[data-sr-funnel-summary]');
  const MAX_FUNNEL_STEP = (() => {
    const n = parseInt(root.dataset.srMaxStep || '3', 10);
    return Number.isFinite(n) && n > 0 ? n : 3;
  })();
  const priceEls = root.querySelectorAll('[data-sr-price]');
  const compareEls = root.querySelectorAll('[data-sr-compare]');
  const saveEls = root.querySelectorAll('[data-sr-save]');
  const sizingKitId = parseInt(root.getAttribute('data-sizing-kit-id') || '0', 10);

  function fq(sel) {
    return root.querySelector(sel) || modal?.querySelector(sel) || null;
  }
  function fqa(sel) {
    const seen = new Set();
    const out = [];
    root.querySelectorAll(sel).forEach((el) => {
      if (!seen.has(el)) {
        seen.add(el);
        out.push(el);
      }
    });
    modal?.querySelectorAll(sel).forEach((el) => {
      if (!seen.has(el)) {
        seen.add(el);
        out.push(el);
      }
    });
    return out;
  }

  const state = {
    qty: 1,
    bundleLabel: '',
    bundlePrice: 0,
    bundleCompare: 0,
    activeThumb: 0,
    manualSrc: null,
    step: 0,
    sizePath: 'know',
  };

  function initDefaultPricing() {
    state.qty = 1;
    state.bundleLabel = '';
    state.bundlePrice = 0;
    state.bundleCompare = 0;
    updateUI();
  }

  function getCheckoutUrl() {
    const rootPath =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const base = window.location.origin + (rootPath.startsWith('/') ? rootPath : '/' + rootPath);
    return new URL('checkout', base.endsWith('/') ? base : base + '/').href;
  }

  function goToCheckout() {
    const checkoutUrl = getCheckoutUrl();
    const link = document.createElement('a');
    link.href = checkoutUrl;
    link.setAttribute('target', '_top');
    link.rel = 'noopener noreferrer';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();

    setTimeout(() => {
      try {
        const topWin = window.top || window;
        topWin.location.href = checkoutUrl;
      } catch (e) {
        window.location.href = checkoutUrl;
      }
    }, 120);
  }

  function openModal() {
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sr-modal-open');
    document.body.classList.add('sr-modal-open');
    // Sticky must never sit over the funnel (esp. mobile Next / ATC)
    if (stickyBar) {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
      stickyBar.hidden = true;
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    unlockPageScroll();
    if (stickyBar) stickyBar.hidden = false;
  }

  function setFunnelStep(step) {
    const next = Math.max(0, Math.min(MAX_FUNNEL_STEP, Number(step) || 0));
    state.step = next;

    if (next === 0) {
      closeModal();
    } else {
      openModal();
    }

    if (funnelRoot instanceof HTMLElement) {
      funnelRoot.setAttribute('data-step', String(Math.max(1, next)));
      funnelRoot.classList.toggle('is-funnel-active', next > 0);
    }

    root.querySelectorAll('[data-sr-step]').forEach((panel) => {
      const n = parseInt(panel.getAttribute('data-sr-step') || '0', 10);
      const show = next > 0 && n === next;
      panel.hidden = !show;
      panel.classList.toggle('is-active', show);
    });
    // Panels live in teleported modal (body or .page-wrapper)
    if (modal && !root.contains(modal)) {
      modal.querySelectorAll('[data-sr-step]').forEach((panel) => {
        const n = parseInt(panel.getAttribute('data-sr-step') || '0', 10);
        const show = next > 0 && n === next;
        panel.hidden = !show;
        panel.classList.toggle('is-active', show);
      });
    }

    if (atcBtn instanceof HTMLElement) {
      atcBtn.hidden = next !== MAX_FUNNEL_STEP;
    }

    // Refresh size-path panels when entering size step
    if (next === 2 || (MAX_FUNNEL_STEP === 2 && next === MAX_FUNNEL_STEP)) {
      applySizePath(state.sizePath);
    }

    updateUI();
    if (typeof updateSticky === 'function') updateSticky();
  }

  function applySizePath(path) {
    state.sizePath = path === 'kit' ? 'kit' : 'know';
    fqa('[data-sr-size-path]').forEach((card) => {
      const match = card.getAttribute('data-sr-size-path') === state.sizePath;
      card.classList.toggle('is-selected', match);
      card.setAttribute('aria-checked', match ? 'true' : 'false');
    });
    const knowEl = fq('[data-sr-size-know]');
    const kitEl = fq('[data-sr-size-kit]');
    if (knowEl) {
      if (state.sizePath === 'know') knowEl.removeAttribute('hidden');
      else knowEl.setAttribute('hidden', '');
    }
    if (kitEl) {
      if (state.sizePath === 'kit') kitEl.removeAttribute('hidden');
      else kitEl.setAttribute('hidden', '');
    }
    updateFunnelImage();
  }

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(Number(cents) / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function findVariantFor(color, size) {
    return productVariants.find((v) => {
      if (colorOptionIndex >= 0 && color) {
        if (String(v['option' + (colorOptionIndex + 1)]) !== color) return false;
      }
      if (sizeOptionIndex >= 0 && size) {
        if (String(v['option' + (sizeOptionIndex + 1)]) !== size) return false;
      }
      return true;
    });
  }

  function imageForColor(color) {
    if (color && colorImageMap[color]) return colorImageMap[color];
    const v = productVariants.find((variant) => {
      if (colorOptionIndex < 0) return false;
      return String(variant['option' + (colorOptionIndex + 1)]) === color && variant.featured_image;
    });
    const featured = v?.featured_image;
    if (featured && typeof featured === 'object' && featured.src) return featured.src;
    if (typeof featured === 'string') return featured;
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    return '';
  }

  function setImg(el, src) {
    if (!(el instanceof HTMLImageElement) || !src) return;
    // Clear srcset/sizes so the browser actually shows the chosen thumb
    el.removeAttribute('srcset');
    el.removeAttribute('sizes');
    el.src = src;
    el.hidden = false;
  }

  function updateSizePathThumbs() {
    const knowThumb = fq('[data-sr-size-thumb="know"]');
    const kitThumb = fq('[data-sr-size-thumb="kit"]');

    if (knowThumb instanceof HTMLImageElement) {
      const knowSrc =
        imageForColor(units[0].color) || knowThumb.getAttribute('data-default-src') || knowThumb.currentSrc || knowThumb.src;
      if (knowSrc) setImg(knowThumb, knowSrc);
    }

    if (kitThumb instanceof HTMLImageElement) {
      const kitSrcEl = fq('[data-sr-kit-img-src]');
      const kitSrc =
        (kitSrcEl instanceof HTMLImageElement ? kitSrcEl.currentSrc || kitSrcEl.src : '') ||
        kitThumb.getAttribute('data-default-src') ||
        kitThumb.currentSrc ||
        kitThumb.src;
      if (kitSrc) setImg(kitThumb, kitSrc);
    }
  }

  function getMainImg() {
    return (
      root.querySelector('.sr-main-media img[data-sr-main-img]') ||
      root.querySelector('.sr-main-media img') ||
      mainImg ||
      heroImg ||
      root.querySelector('[data-sr-hero-img]')
    );
  }

  function updateUnitVisibility() {
    const buy = funnelRoot || root.querySelector('.sr-buy') || root;
    // Only hide ring-1 main options inside the upsell step when multi-qty is selected
    buy.classList.toggle('sr-main-options-hidden', state.qty > 1 && state.step === MAX_FUNNEL_STEP);

    root.querySelectorAll('[data-sr-bundle-card]').forEach((card) => {
      const qty = parseInt(card.getAttribute('data-qty') || '1', 10);
      const panel = card.querySelector('[data-sr-bundle-panel]');
      const btn = card.querySelector('[data-sr-bundle]');
      const isSelected = qty === state.qty;

      card.classList.toggle('is-open', isSelected && state.qty > 1);
      if (panel) {
        if (isSelected && state.qty > 1) {
          panel.hidden = false;
        } else {
          panel.hidden = true;
        }
      }
      if (btn) {
        btn.setAttribute('aria-expanded', isSelected && state.qty > 1 ? 'true' : 'false');
      }
    });
  }

  function syncUnitButtons(unitIndex) {
    const u = units[unitIndex];
    // Sync all matching controls (main + open panel duplicates for ring 1)
    fqa(`[data-sr-unit-color="${unitIndex + 1}"]`).forEach((btn) => {
      const match = btn.getAttribute('data-color') === u.color;
      btn.classList.toggle('is-selected', match);
      btn.setAttribute('aria-checked', match ? 'true' : 'false');
    });
    fqa(`[data-sr-unit-size="${unitIndex + 1}"]`).forEach((btn) => {
      const match = btn.getAttribute('data-size') === u.size;
      btn.classList.toggle('is-selected', match);
      btn.setAttribute('aria-checked', match ? 'true' : 'false');
    });
  }

  function updateAvailability(unitIndex) {
    const color = units[unitIndex].color;
    fqa(`[data-sr-unit-size="${unitIndex + 1}"]`).forEach((btn) => {
      const sizeVal = btn.getAttribute('data-size');
      if (sizeOptionIndex < 0 || !sizeVal) return;
      const available = productVariants.some((v) => {
        if (String(v['option' + (sizeOptionIndex + 1)]) !== sizeVal) return false;
        if (colorOptionIndex >= 0 && color) {
          if (String(v['option' + (colorOptionIndex + 1)]) !== color) return false;
        }
        return v.available;
      });
      btn.classList.toggle('is-unavailable', !available);
      btn.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  }

  function updateFunnelImage() {
    const funnelImg = fq('[data-sr-funnel-img]');
    if (!(funnelImg instanceof HTMLImageElement)) return;

    let src = '';
    if (state.sizePath === 'kit' && state.step >= 2) {
      const kitSrcEl = fq('[data-sr-kit-img-src]');
      src = kitSrcEl instanceof HTMLImageElement ? kitSrcEl.currentSrc || kitSrcEl.src : '';
    }
    if (!src) {
      src =
        state.manualSrc ||
        imageForColor(units[0].color) ||
        funnelImg.getAttribute('data-default-src') ||
        '';
    }
    if (src) setImg(funnelImg, src);
  }

  function updateGallery() {
    const activeColor = units[0].color;
    const primarySrc = state.manualSrc || imageForColor(activeColor);

    // Main offer image (single large photo)
    if (primarySrc) {
      setImg(getMainImg(), primarySrc);
    }

    updateFunnelImage();
    updateSizePathThumbs();

    // Thumbs: highlight selected / color match
    if (thumbs) {
      const thumbBtns = thumbs.querySelectorAll('[data-sr-thumb]');
      thumbBtns.forEach((btn, i) => {
        const color = btn.getAttribute('data-color') || '';
        const src = btn.getAttribute('data-src') || '';
        let isActive = false;
        if (state.manualSrc) {
          isActive = src === state.manualSrc || i === state.activeThumb;
        } else {
          isActive =
            (color && color === activeColor) ||
            (!color && i === state.activeThumb);
        }
        btn.classList.toggle('is-active', Boolean(isActive));
      });
    }

    // Bundle preview strip: only for multi-ring (avoid duplicating the main photo)
    if (bundleGallery) {
      if (state.qty < 2) {
        bundleGallery.innerHTML = '';
        bundleGallery.hidden = true;
      } else {
        const html = [];
        for (let i = 0; i < state.qty; i++) {
          const src = imageForColor(units[i].color);
          const label = units[i].color || 'Ring ' + (i + 1);
          if (src) {
            html.push(
              `<div class="sr-bundle-gal__item"><img src="${src}" alt="${label}" loading="lazy"><span>Ring ${i + 1}${units[i].color ? ' · ' + units[i].color : ''}${units[i].size ? ' / ' + units[i].size : ''}</span></div>`
            );
          }
        }
        bundleGallery.innerHTML = html.join('');
        bundleGallery.hidden = false;
      }
    }

    // Per-unit mini previews (main + panels)
    for (let i = 0; i < 3; i++) {
      const src = imageForColor(units[i].color);
      fqa(`[data-sr-unit-img="${i + 1}"]`).forEach((img) => setImg(img, src));
    }

    // Left narrative gallery: highlight images matching selected colors
    root.querySelectorAll('[data-sr-gallery-item]').forEach((item) => {
      const color = item.getAttribute('data-color') || '';
      const selectedColors = units.slice(0, state.qty).map((u) => u.color);
      item.classList.toggle('is-selected-color', color !== '' && selectedColors.includes(color));
    });
  }

  function updateUI() {
    updateUnitVisibility();
    for (let i = 0; i < state.qty; i++) updateAvailability(i);

    const primary = findVariantFor(units[0].color, units[0].size);
    if (primary && variantInput) variantInput.value = String(primary.id);
    if (qtyInput instanceof HTMLInputElement) qtyInput.value = '1'; // multi-add handled in JS

    if (bundleProp instanceof HTMLInputElement) {
      const detail = units
        .slice(0, state.qty)
        .map((u, i) => `Ring${i + 1}:${u.color}/${u.size}`)
        .join(' | ');
      bundleProp.value = (state.bundleLabel || '') + ' — ' + detail;
    }

    updateGallery();

    let displayCents = state.bundlePrice;
    let compareCents = state.bundleCompare;
    if (!displayCents && primary) {
      displayCents = Number(primary.price) * state.qty;
      compareCents = primary.compare_at_price
        ? Number(primary.compare_at_price) * state.qty
        : 0;
    }

    if (priceEls.length) {
      priceEls.forEach((el) => {
        el.textContent = formatMoney(displayCents);
      });
    } else if (priceEl) {
      priceEl.textContent = formatMoney(displayCents);
    }

    const syncCompare = (el) => {
      if (!(el instanceof HTMLElement)) return;
      if (compareCents > displayCents) {
        el.textContent = formatMoney(compareCents);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    };
    if (compareEls.length) compareEls.forEach(syncCompare);
    else syncCompare(compareEl);

    const syncSave = (el) => {
      if (!(el instanceof HTMLElement)) return;
      if (compareCents > displayCents) {
        const pct = Math.round(((compareCents - displayCents) / compareCents) * 100);
        el.textContent = 'SAVE ' + pct + '%';
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    };
    if (saveEls.length) saveEls.forEach(syncSave);
    else syncSave(saveEl);

    if (stickyPrice) stickyPrice.textContent = formatMoney(displayCents);
    if (stickyVariantEl) {
      const parts = [units[0].color, units[0].size].filter(Boolean);
      stickyVariantEl.textContent = parts.join(' / ');
    }
    if (stickyImg instanceof HTMLImageElement) {
      const src = imageForColor(units[0].color) || primary?.featured_image?.src || '';
      if (src) setImg(stickyImg, src);
    }
    if (stickyTitle && !stickyTitle.textContent?.trim()) {
      stickyTitle.textContent = product.title || '';
    }

    if (selectedColorEl) {
      selectedColorEl.textContent = units[0].color || '';
    }
    root.querySelectorAll('[data-sr-selected-color]').forEach((el) => {
      el.textContent = units[0].color || '';
    });
    if (funnelSummaryEl) {
      const parts = [units[0].color, units[0].size].filter(Boolean);
      funnelSummaryEl.textContent = parts.length ? parts.join(' · ') : '';
    }

    let canAdd = true;
    if (state.sizePath === 'kit') {
      canAdd = Boolean(sizingKitId);
    } else {
      for (let i = 0; i < state.qty; i++) {
        const v = findVariantFor(units[i].color, units[i].size);
        if (!v || !v.available) {
          canAdd = false;
          break;
        }
      }
    }

    addButtons.forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      // Sticky opens the funnel until the last step — keep it clickable
      if (btn.hasAttribute('data-sr-sticky-add') && state.step < MAX_FUNNEL_STEP) {
        btn.disabled = false;
        const startLabel = btn.dataset.addText || 'Get started';
        const labelEl = btn.querySelector('[data-sr-sticky-label]');
        if (labelEl) labelEl.textContent = startLabel;
        btn.setAttribute('aria-label', startLabel);
        return;
      }
      btn.disabled = !canAdd;
      const label = !canAdd
        ? btn.dataset.soldOutText || 'Sold out'
        : btn.dataset.addText || 'Add to Cart';
      if (btn.hasAttribute('data-sr-sticky-add')) {
        const labelEl = btn.querySelector('[data-sr-sticky-label]');
        if (labelEl) labelEl.textContent = label;
        btn.setAttribute('aria-label', label);
      } else {
        btn.textContent = label;
      }
    });
  }

  fqa('[data-sr-unit-color]').forEach((el) => {
    el.addEventListener('click', () => {
      const unitIndex = parseInt(el.getAttribute('data-sr-unit-color') || '1', 10) - 1;
      const color = el.getAttribute('data-color') || '';
      units[unitIndex].color = color;
      syncUnitButtons(unitIndex);
      // If ring 1 color changes, drive main gallery
      if (unitIndex === 0) {
        state.activeThumb = 0;
        state.manualSrc = null;
      }
      updateUI();
    });
  });

  fqa('[data-sr-unit-size]').forEach((el) => {
    el.addEventListener('click', () => {
      if (el.classList.contains('is-unavailable')) return;
      const unitIndex = parseInt(el.getAttribute('data-sr-unit-size') || '1', 10) - 1;
      const size = el.getAttribute('data-size') || '';
      units[unitIndex].size = size;
      syncUnitButtons(unitIndex);
      updateUI();
    });
  });

  fqa('[data-sr-size-path]').forEach((btn) => {
    btn.addEventListener('click', () => {
      applySizePath(btn.getAttribute('data-sr-size-path') || 'know');
      updateUI();
    });
  });

  root.querySelectorAll('[data-sr-bullets-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const extras = root.querySelectorAll('[data-sr-bullets-more]');
      if (!extras.length) return;
      const open = extras[0].hasAttribute('hidden');
      extras.forEach((el) => {
        if (open) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open
        ? btn.getAttribute('data-less-label') || 'Show less'
        : btn.getAttribute('data-more-label') || 'Read more';
    });
  });

  root.querySelectorAll('[data-sr-desc-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const desc = btn.closest('.sr-buy__desc-wrap')?.querySelector('[data-sr-desc]');
      if (!desc) return;
      const open = !desc.classList.contains('is-expanded');
      desc.classList.toggle('is-expanded', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open
        ? btn.getAttribute('data-less-label') || 'Show less'
        : btn.getAttribute('data-more-label') || 'Read more';
    });
  });

  root.querySelectorAll('[data-sr-bundle]').forEach((el) => {
    el.addEventListener('click', () => {
      const qty = parseInt(el.getAttribute('data-qty') || '1', 10);
      state.qty = qty;
      state.bundlePrice = parseInt(el.getAttribute('data-price-cents') || '0', 10);
      state.bundleCompare = parseInt(el.getAttribute('data-compare-cents') || '0', 10);
      state.bundleLabel = el.getAttribute('data-label') || '';

      root.querySelectorAll('[data-sr-bundle]').forEach((b) => {
        b.classList.toggle('is-selected', b === el);
        b.setAttribute('aria-checked', b === el ? 'true' : 'false');
      });

      updateUI();
    });
  });

  // Thumb clicks → swap the large gallery image
  root.querySelectorAll('[data-sr-thumb]').forEach((btn, i) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const src = btn.getAttribute('data-src');
      const color = btn.getAttribute('data-color');
      state.activeThumb = i;
      state.manualSrc = src || null;

      if (src) setImg(getMainImg(), src);

      if (color) {
        units[0].color = color;
        syncUnitButtons(0);
      }

      root.querySelectorAll('[data-sr-thumb]').forEach((b, idx) => {
        b.classList.toggle('is-active', idx === i);
      });
      updateUI();
    });
  });

  // Thumbnail strip: arrows + hidden scrollbar (touch pan still works)
  (function initThumbsNav() {
    const navs = root.querySelectorAll('[data-sr-thumbs-nav]');
    const mqMobile = window.matchMedia('(max-width: 900px)');

    navs.forEach((nav) => {
      const strip = nav.querySelector('[data-sr-thumbs]');
      const prev = nav.querySelector('[data-sr-thumbs-prev]');
      const next = nav.querySelector('[data-sr-thumbs-next]');
      const mainMedia =
        nav.parentElement?.querySelector('.sr-main-media') ||
        root.querySelector('.sr-main-media');
      if (!strip) return;

      const isMobile = () => mqMobile.matches;

      const syncHeight = () => {
        if (isMobile() || !mainMedia) {
          nav.style.height = '';
          nav.style.maxHeight = '';
          return;
        }
        const h = Math.round(mainMedia.getBoundingClientRect().height);
        if (h > 0) {
          nav.style.height = h + 'px';
          nav.style.maxHeight = h + 'px';
        }
      };

      const step = () =>
        isMobile()
          ? Math.max(80, Math.round(strip.clientWidth * 0.8))
          : Math.max(72, Math.round(strip.clientHeight * 0.75));

      const syncArrows = () => {
        if (isMobile()) {
          const max = Math.max(0, strip.scrollWidth - strip.clientWidth);
          const left = strip.scrollLeft;
          const canScroll = max > 4;
          if (prev) {
            prev.hidden = !canScroll;
            prev.classList.toggle('is-disabled', left <= 2);
            prev.disabled = left <= 2;
          }
          if (next) {
            next.hidden = !canScroll;
            next.classList.toggle('is-disabled', left >= max - 2);
            next.disabled = left >= max - 2;
          }
          return;
        }
        const max = Math.max(0, strip.scrollHeight - strip.clientHeight);
        const top = strip.scrollTop;
        const canScroll = max > 4;
        if (prev) {
          prev.hidden = !canScroll;
          prev.classList.toggle('is-disabled', top <= 2);
          prev.disabled = top <= 2;
        }
        if (next) {
          next.hidden = !canScroll;
          next.classList.toggle('is-disabled', top >= max - 2);
          next.disabled = top >= max - 2;
        }
      };

      const refresh = () => {
        syncHeight();
        syncArrows();
      };

      prev &&
        prev.addEventListener('click', (e) => {
          e.preventDefault();
          if (isMobile()) strip.scrollBy({ left: -step(), behavior: 'smooth' });
          else strip.scrollBy({ top: -step(), behavior: 'smooth' });
        });
      next &&
        next.addEventListener('click', (e) => {
          e.preventDefault();
          if (isMobile()) strip.scrollBy({ left: step(), behavior: 'smooth' });
          else strip.scrollBy({ top: step(), behavior: 'smooth' });
        });

      strip.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', refresh);
      if (typeof mqMobile.addEventListener === 'function') {
        mqMobile.addEventListener('change', refresh);
      } else if (typeof mqMobile.addListener === 'function') {
        mqMobile.addListener(refresh);
      }
      if (mainMedia && typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(refresh);
        ro.observe(mainMedia);
      }
      refresh();
      requestAnimationFrame(refresh);
      window.addEventListener('load', refresh, { once: true });
    });
  })();

  // Bind funnel FIRST so a later init error can't kill Get started
  function openFunnelFromCta(e) {
    if (e) e.preventDefault();
    try {
      setFunnelStep(1);
    } catch (err) {
      console.error('[smart-ring-pdp] open funnel failed', err);
    }
  }

  document.addEventListener(
    'click',
    (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const startBtn = t.closest('[data-sr-funnel-start]');
      if (startBtn) {
        openFunnelFromCta(e);
        return;
      }
      const nextBtn = t.closest('[data-sr-funnel-next]');
      if (nextBtn && (root.contains(nextBtn) || (modal && modal.contains(nextBtn)))) {
        e.preventDefault();
        if (state.step === 1 && !units[0].color) {
          if (errorEl) {
            errorEl.textContent = 'Please choose a color.';
            errorEl.classList.add('is-visible');
          }
          return;
        }
        if (state.step === 2 && state.sizePath !== 'kit' && !units[0].size) {
          if (errorEl) {
            errorEl.textContent = 'Please choose a size.';
            errorEl.classList.add('is-visible');
          }
          return;
        }
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
        }
        if (state.step === 2 && state.sizePath === 'kit') {
          state.qty = 1;
          setFunnelStep(MAX_FUNNEL_STEP);
          form?.requestSubmit?.();
          return;
        }
        const nextStep = state.step + 1;
        if (nextStep > MAX_FUNNEL_STEP) return;
        setFunnelStep(nextStep);
        return;
      }
      const backBtn = t.closest('[data-sr-funnel-back]');
      if (backBtn && (root.contains(backBtn) || (modal && modal.contains(backBtn)))) {
        e.preventDefault();
        if (state.step <= 1) setFunnelStep(0);
        else setFunnelStep(state.step - 1);
        return;
      }
      const closeBtn = t.closest('[data-sr-modal-close]');
      if (closeBtn && modal && modal.contains(closeBtn)) {
        e.preventDefault();
        setFunnelStep(0);
      }
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && state.step > 0) setFunnelStep(0);
  });

  // Init selections — always unlock scroll first (leftover lock = blank / stuck page)
  unlockPageScroll();
  try {
    for (let i = 0; i < 3; i++) syncUnitButtons(i);

    const defaultBundle =
      root.querySelector('[data-sr-bundle].is-selected') ||
      root.querySelector('[data-sr-bundle]');
    if (defaultBundle instanceof HTMLElement) defaultBundle.click();
    else initDefaultPricing();

    applySizePath('know');
    setFunnelStep(0);
  } catch (err) {
    console.error('[smart-ring-pdp] init failed', err);
    unlockPageScroll();
  }

  // FAQ
  root.querySelectorAll('[data-sr-faq-item]').forEach((item) => {
    const btn = item.querySelector('[data-sr-faq-q]');
    btn?.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  const buyBox = root.querySelector('.sr-buy');
  const topBlock = root.querySelector('.sr-top');
  const heroBlock = root.closest('.vy-hero') || root.closest('.vy-lp__section');

  function getScrollY() {
    if (pageWrapper) return pageWrapper.scrollTop || 0;
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function updateSticky() {
    if (!stickyBar) return;
    if (state.step > 0) {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
      return;
    }

    const isLanding = root.classList.contains('vy-lp-buy');
    const watchEl = topBlock || buyBox || mainAddBtn || heroBlock;
    let show = false;

    if (watchEl) {
      const rect = watchEl.getBoundingClientRect();
      // Show once the offer / buy block has mostly left the first viewport
      show = rect.bottom < Math.min(120, window.innerHeight * 0.2);
    } else {
      show = getScrollY() > 280;
    }

    // Landing: slightly earlier so sticky appears after hero buy box
    if (isLanding && buyBox) {
      const buyRect = buyBox.getBoundingClientRect();
      show = buyRect.bottom < window.innerHeight * 0.5;
    }

    stickyBar.classList.toggle('is-visible', show);
    stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  const scrollOpts = { passive: true };
  window.addEventListener('scroll', updateSticky, scrollOpts);
  if (pageWrapper) pageWrapper.addEventListener('scroll', updateSticky, scrollOpts);
  window.addEventListener('resize', updateSticky);
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(() => updateSticky(), {
      threshold: [0, 0.01, 0.1, 0.25, 0.5, 1],
      root: null,
    });
    if (buyBox) io.observe(buyBox);
    if (mainAddBtn) io.observe(mainAddBtn);
    if (topBlock) io.observe(topBlock);
    if (heroBlock) io.observe(heroBlock);
  }
  updateSticky();
  requestAnimationFrame(updateSticky);
  setTimeout(updateSticky, 400);

  async function addToCart(e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
    if (errorEl) {
      errorEl.classList.remove('is-visible');
      errorEl.textContent = '';
    }

    /** @type {{ id: number, quantity: number, properties: Record<string, string> }[]} */
    const items = [];

    if (state.sizePath === 'kit') {
      if (!sizingKitId) {
        if (errorEl) {
          errorEl.textContent = 'Sizing kit product is not configured.';
          errorEl.classList.add('is-visible');
        }
        return;
      }
      items.push({
        id: sizingKitId,
        quantity: 1,
        properties: {
          _bundle: 'Sizing kit',
          Color: units[0].color || '',
          Size: 'Sizing kit',
        },
      });
    } else {
      for (let i = 0; i < state.qty; i++) {
        const v = findVariantFor(units[i].color, units[i].size);
        if (!v || !v.available) {
          if (errorEl) {
            errorEl.textContent = 'Please choose color and size for each ring.';
            errorEl.classList.add('is-visible');
          }
          return;
        }
        items.push({
          id: Number(v.id),
          quantity: 1,
          properties: {
            _bundle: state.bundleLabel || String(state.qty),
            Ring: String(i + 1),
            Color: units[i].color || '',
            Size: units[i].size || '',
          },
        });
      }
    }

    addButtons.forEach((b) => {
      if (b instanceof HTMLButtonElement) b.disabled = true;
    });

    try {
      const cartAddUrl =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ||
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js');

      const payload = { items };

      const res = await fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });

      let data = {};
      const raw = await res.text();
      try {
        data = raw ? JSON.parse(raw) : {};
      } catch (parseErr) {
        throw new Error('Could not add to cart. Please try again.');
      }

      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      goToCheckout();
      return;
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err instanceof Error ? err.message : 'Error adding to cart';
        errorEl.classList.add('is-visible');
      }
    } finally {
      updateUI();
    }
  }

  form?.addEventListener('submit', addToCart, true);

  if (atcBtn instanceof HTMLButtonElement) {
    atcBtn.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
        addToCart(e);
      },
      true
    );
  }

  document.querySelectorAll('[data-sr-sticky-add]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (state.step < MAX_FUNNEL_STEP) {
        setFunnelStep(state.step === 0 ? 1 : Math.max(1, state.step));
        return;
      }
      form?.requestSubmit?.();
    });
  });

  // Size guide link → scroll + open accordion (closed by default)
  root.querySelectorAll('a.sr-size-guide[href="#sr-size-guide"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('sr-size-guide');
      if (!target) return;
      if (target instanceof HTMLDetailsElement) {
        target.open = true;
      }
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Pitch video: muted autoplay when in view (Safari/Chrome safe)
  if (pitchVideo instanceof HTMLVideoElement) {
    const videoWrap = pitchVideo.closest('[data-sr-pitch-video]') || pitchVideo;
    pitchVideo.muted = true;
    pitchVideo.defaultMuted = true;
    pitchVideo.volume = 0;
    pitchVideo.loop = true;
    pitchVideo.playsInline = true;
    pitchVideo.setAttribute('muted', '');
    pitchVideo.setAttribute('playsinline', '');
    pitchVideo.setAttribute('webkit-playsinline', '');
    pitchVideo.setAttribute('autoplay', '');

    const tryPlay = () => {
      pitchVideo.muted = true;
      pitchVideo.volume = 0;
      const p = pitchVideo.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {
          // Retry once after a short delay (mobile autoplay policies)
          setTimeout(() => {
            pitchVideo.muted = true;
            pitchVideo.play()?.catch?.(() => {});
          }, 250);
        });
      }
    };

    const syncVideo = (visible) => {
      if (visible) tryPlay();
      else if (!pitchVideo.paused) pitchVideo.pause();
    };

    if ('IntersectionObserver' in window) {
      const vio = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            syncVideo(entry.isIntersecting);
          });
        },
        { threshold: [0, 0.15, 0.4], rootMargin: '80px 0px 80px 0px' }
      );
      vio.observe(videoWrap);
    } else {
      tryPlay();
    }

    pitchVideo.addEventListener('loadeddata', () => {
      const rect = videoWrap.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;
      if (inView) tryPlay();
    });

    // One-time unlock on first user gesture (required on some mobile browsers)
    const unlock = () => {
      tryPlay();
      document.removeEventListener('touchstart', unlock);
      document.removeEventListener('click', unlock);
    };
    document.addEventListener('touchstart', unlock, { passive: true, once: true });
    document.addEventListener('click', unlock, { once: true });
  }
})();
